import React, { useEffect, useRef } from 'react';
import VanillaTilt from 'vanilla-tilt';
import styles from './Features.module.scss';

const FeatureCard = ({ title, desc, children }) => {
  const cardRef = useRef(null);

  useEffect(() => {
    if (cardRef.current) {
      VanillaTilt.init(cardRef.current, {
        max: 10,
        speed: 1000,
        perspective: 1000,
        glare: true,
        'max-glare': 0.1,
        scale: 1.02,
        reset: true,
      });
    }
    return () => {
      if (cardRef.current?.vanillaTilt) {
        cardRef.current.vanillaTilt.destroy();
      }
    };
  }, []);

  return (
    <div ref={cardRef} className={styles.featureCard}>
      <div className={styles.featureCard__iconWrapper}>{children}</div>
      <h3 className={styles.featureCard__title}>{title}</h3>
      <p className={styles.featureCard__desc}>{desc}</p>
    </div>
  );
};

const Features = () => {
  return (
    <section id='features' className={styles.features}>
      <div className={styles.features__container}>
        <div className={styles.features__header}>
          <h2 className={styles.features__title}>
            Всё, что нужно для контроля
          </h2>
          <p className={styles.features__subtitle}>
            Мы убрали сложные таблицы и оставили только те инструменты, которые
            реально помогают управлять капиталом.
          </p>
        </div>

        <div className={styles.features__grid}>
          <FeatureCard
            title='Умный учет транзакций'
            desc='Добавляйте доходы и расходы в пару кликов. Распределяйте по категориям и следите за балансом в реальном времени.'>
            <svg
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
              className={styles.featureCard__icon}>
              <path d='M21 12V7H5a2 2 0 0 1 0-4h14v4' />
              <path d='M3 5v14a2 2 0 0 0 2 2h16v-5' />
              <path d='M18 12a2 2 0 0 0 0 4h4v-4Z' />
            </svg>
          </FeatureCard>

          <FeatureCard
            title='Финансовые цели'
            desc='Создавайте копилки на мечту. Отслеживайте прогресс, планируйте бюджет и достигайте результатов быстрее.'>
            <svg
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
              className={styles.featureCard__icon}>
              <circle cx='12' cy='12' r='10' />
              <path d='M12 6v6l4 2' />
            </svg>
          </FeatureCard>

          <FeatureCard
            title='Наглядная аналитика'
            desc='Понятные графики и диаграммы. Изучайте свои привычки и находите категории, где можно сэкономить.'>
            <svg
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
              className={styles.featureCard__icon}>
              <line x1='18' y1='20' x2='18' y2='10' />
              <line x1='12' y1='20' x2='12' y2='4' />
              <line x1='6' y1='20' x2='6' y2='14' />
            </svg>
          </FeatureCard>
        </div>
      </div>
    </section>
  );
};

export default Features;
